/* ============================================
   ONLYPANS — Theme JavaScript
   ============================================ */
(function () {
  'use strict';

  window.OP = window.OP || {};
  window.OP.routes = window.OP.routes || {
    cart_url: '/cart',
    cart_add_url: '/cart/add.js',
    cart_change_url: '/cart/change.js',
  };

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.from((scope || document).querySelectorAll(selector));
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });
  }

  /* ===========================================
     1. Announcement Bar Rotation
     =========================================== */

  function initAnnouncement() {
    var el = $('.op-announcement__text');
    if (!el) return;

    var jsonEl = document.getElementById('announcement-messages');
    var messages;
    try {
      messages = JSON.parse(jsonEl.textContent);
    } catch (e) {
      messages = [
        'DROP LIVE 🔥',
        'CERTIFIED HOT FITS',
        'WARNING: KITCHEN CONFIDENCE',
      ];
    }
    if (!messages || messages.length < 2) return;
    var idx = 0;

    setInterval(function () {
      el.style.transform = 'translateY(-100%)';
      el.style.opacity = '0';

      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        el.textContent = messages[idx];
        el.style.transform = 'translateY(100%)';
        el.offsetHeight; // force reflow
        el.style.transform = 'translateY(0)';
        el.style.opacity = '1';
      }, 300);
    }, 3000);
  }

  /* ===========================================
     2. Sticky Header
     =========================================== */

  function initStickyHeader() {
    var header = $('.op-header');
    if (!header) return;

    var threshold = 50;

    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===========================================
     3. Mobile Menu Toggle
     =========================================== */

  function initMobileMenu() {
    var toggle = $('.op-header__menu-toggle');
    var nav = $('.op-header__nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      document.body.classList.toggle('menu-open');
    });
  }

  /* ===========================================
     4. Cart Drawer
     =========================================== */

  function initCartDrawer() {
    var drawer = $('.op-cart-drawer');
    if (!drawer) return;

    var itemsContainer = $('.op-cart-drawer__items', drawer);

    function openDrawer() {
      drawer.classList.add('open');
      document.body.classList.add('cart-open');
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      document.body.classList.remove('cart-open');
    }

    function updateCartCount(count) {
      $$('.op-cart-count').forEach(function (el) {
        el.textContent = count;
      });
    }

    function renderCartItems(cart) {
      if (!itemsContainer) return;

      var footer = $('.op-cart-drawer__footer', drawer);
      var totalPrice = $('.op-cart-drawer__total-price', drawer);

      if (!cart.items.length) {
        itemsContainer.innerHTML =
          '<div class="op-cart-drawer__empty">' +
            '<p>Your cart is empty.</p>' +
            '<p class="op-label">Time to turn up the heat.</p>' +
            '<a href="/collections/all" class="op-btn op-btn--primary">Shop Now</a>' +
          '</div>';
        if (footer) footer.style.display = 'none';
        return;
      }

      itemsContainer.innerHTML = cart.items
        .map(function (item, i) {
          var line = i + 1;
          var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          var variantHtml = variantTitle ? '<p class="op-cart-item__variant">' + variantTitle + '</p>' : '';
          return (
            '<div class="op-cart-item" data-line="' + line + '">' +
              '<img src="' + item.image + '" alt="' + item.title + '">' +
              '<div class="op-cart-item__details">' +
                '<h4>' + item.title + '</h4>' +
                variantHtml +
                '<p class="op-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
              '</div>' +
              '<button class="js-cart-remove op-cart-item__remove" data-line="' + line + '">&times;</button>' +
            '</div>'
          );
        })
        .join('');

      if (footer) footer.style.display = '';
      if (totalPrice) totalPrice.textContent = formatMoney(cart.total_price);
    }

    function refreshCart() {
      return fetchJSON('/cart.js').then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
        return cart;
      });
    }

    // Open triggers
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-cart-toggle');
      if (trigger) {
        e.preventDefault();
        refreshCart().then(openDrawer);
      }
    });

    // Close triggers
    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.op-cart-drawer__close') ||
        e.target.closest('.op-cart-drawer__overlay')
      ) {
        closeDrawer();
      }
    });

    function handleAddToCart(form, btn) {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      var formData;
      if (form) {
        formData = new FormData(form);
      } else if (btn && btn.dataset.variantId) {
        formData = new FormData();
        formData.append('id', btn.dataset.variantId);
        formData.append('quantity', 1);
      } else {
        return;
      }

      fetch(window.OP.routes.cart_add_url, {
        method: 'POST',
        body: formData,
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.statusText);
          return r.json();
        })
        .then(function () {
          return refreshCart();
        })
        .then(function () {
          openDrawer();
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Added ✓';
            setTimeout(function () {
              var priceEl = document.getElementById('op-product-price');
              btn.innerHTML = 'Add to Cart' + (priceEl ? ' &mdash; ' + priceEl.textContent : '');
            }, 1500);
          }
        })
        .catch(function (err) {
          console.error('[OP] Add to cart failed:', err);
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Error — try again';
          }
        });
    }

    // Intercept form submission
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('#op-product-form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.js-add-to-cart');
      handleAddToCart(form, btn);
    });

    // Also intercept button clicks (for buttons outside forms)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-add-to-cart');
      if (!btn) return;
      var form = btn.closest('form');
      if (form && form.id === 'op-product-form') return; // handled by submit listener
      e.preventDefault();
      handleAddToCart(form, btn);
    });

    // Remove from cart (delegated)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-cart-remove');
      if (!btn) return;

      var line = parseInt(btn.dataset.line, 10);

      fetch(window.OP.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.statusText);
          return r.json();
        })
        .then(function () {
          return refreshCart();
        })
        .catch(function (err) {
          console.error('[OP] Remove from cart failed:', err);
        });
    });

    // Initial count fetch
    refreshCart();
  }

  /* ===========================================
     5. Product Description Drawer
     =========================================== */

  function initDescriptionDrawer() {
    var drawer = document.getElementById('op-description-drawer');
    if (!drawer) return;

    var panel = $('.op-description-drawer__panel', drawer);
    var trigger = $('[data-description-drawer-open]');
    var lastActiveElement = null;

    function setExpanded(isExpanded) {
      if (trigger) {
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    }

    function openDrawer() {
      lastActiveElement = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('description-drawer-open');
      setExpanded(true);
      if (panel) panel.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('description-drawer-open');
      setExpanded(false);
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-description-drawer-open]')) {
        e.preventDefault();
        openDrawer();
      }

      if (e.target.closest('[data-description-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        closeDrawer();
      }
    });
  }

  /* ===========================================
     6. Product Variant Selector + Image Carousel
     =========================================== */

  function initVariantSelector() {
    var variantsJson = document.getElementById('op-product-variants');
    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var selectEl = document.getElementById('op-variant-select');
    var priceEl = document.getElementById('op-product-price');

    function getSelectedOptions() {
      var options = [];
      $$('.op-product__option').forEach(function (group) {
        var active = group.querySelector('.op-size-pill.active');
        options.push(active ? active.dataset.value : null);
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return options.every(function (val, i) {
          if (!val) return true;
          return v['option' + (i + 1)] === val;
        });
      });
    }

    function updateProduct(variant) {
      if (!variant) return;

      if (selectEl) selectEl.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      document.dispatchEvent(new CustomEvent('op:variant-change', {
        detail: { variant: variant },
      }));
    }

    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.op-size-pill');
      if (!pill || pill.disabled) return;

      var container = pill.closest('.op-size-pills');
      if (container) {
        $$('.op-size-pill', container).forEach(function (p) {
          p.classList.remove('active');
        });
      }
      pill.classList.add('active');

      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (variant) updateProduct(variant);
    });
  }

  /* ===========================================
     6b. Product Image Carousel
     =========================================== */

  function initProductCarousel() {
    var carousel = document.getElementById('op-product-carousel');
    if (!carousel) return;

    var slides = $$('.op-product__slide', carousel);
    var dotsWrap = document.getElementById('op-product-dots');
    var dots = $$('.op-product__dot');
    var thumbsWrap = $('.op-product__thumbs');
    var thumbs = $$('.op-product__thumb');
    var currentIndex = 0;
    var visibleSlides = slides.slice();
    var visibleDots = dots.slice();
    var visibleThumbs = thumbs.slice();

    function getActiveVariantGroup() {
      var colorGroup = $('.op-product__option .op-size-pill.active');
      return colorGroup ? colorGroup.dataset.value : '';
    }

    function syncVisibleItems() {
      visibleSlides = slides.filter(function (slide) { return !slide.hidden; });
      visibleDots = dots.filter(function (dot) { return !dot.hidden; });
      visibleThumbs = thumbs.filter(function (thumb) { return !thumb.hidden; });

      if (dotsWrap) dotsWrap.hidden = visibleDots.length <= 1;
      if (thumbsWrap) thumbsWrap.hidden = visibleThumbs.length <= 1;
    }

    function getTargetSlideIndex(variantGroup, preferVariantImage) {
      if (!preferVariantImage) return 0;

      var variantSlideIndex = visibleSlides.findIndex(function (slide) {
        return slide.dataset.variantGroup === variantGroup;
      });

      return variantSlideIndex >= 0 ? variantSlideIndex : 0;
    }

    function applyVariantFilter(variantGroup, options) {
      var preferVariantImage = options && options.preferVariantImage;
      var hasMatchingImages = variantGroup && slides.some(function (slide) {
        return slide.dataset.variantGroup === variantGroup;
      });

      slides.forEach(function (slide, index) {
        slide.hidden = hasMatchingImages && index !== 0 && slide.dataset.variantGroup !== variantGroup;
        slide.classList.remove('active');
      });

      dots.forEach(function (dot, index) {
        dot.hidden = hasMatchingImages && index !== 0 && dot.dataset.variantGroup !== variantGroup;
        dot.classList.remove('active');
      });

      thumbs.forEach(function (thumb, index) {
        thumb.hidden = hasMatchingImages && index !== 0 && thumb.dataset.variantGroup !== variantGroup;
        thumb.classList.remove('active');
      });

      syncVisibleItems();
      currentIndex = getTargetSlideIndex(variantGroup, preferVariantImage);

      if (visibleSlides.length) {
        goToSlide(currentIndex, false);
      }
    }

    function goToSlide(index, smooth) {
      if (index < 0 || index >= visibleSlides.length) return;
      currentIndex = index;
      carousel.scrollTo({ left: visibleSlides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      updateIndicators(index);
    }

    function updateIndicators(index) {
      visibleDots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
      visibleThumbs.forEach(function (t, i) { t.classList.toggle('active', i === index); });
    }

    // Sync dots/thumbs on scroll (for swipe)
    var scrollTimer;
    carousel.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = carousel.scrollLeft;
        var slideWidth = carousel.offsetWidth;
        var index = Math.round(scrollLeft / slideWidth);
        if (index !== currentIndex) {
          currentIndex = index;
          updateIndicators(index);
        }
      }, 50);
    }, { passive: true });

    // Dot click
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(visibleDots.indexOf(dot));
      });
    });

    // Thumbnail click (desktop)
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToSlide(visibleThumbs.indexOf(thumb));
      });
    });

    document.addEventListener('op:variant-change', function (event) {
      applyVariantFilter(event.detail.variant.option1, { preferVariantImage: true });
    });

    applyVariantFilter(getActiveVariantGroup(), { preferVariantImage: false });
  }

  /* ===========================================
     6c. Sticky Buy Button (mobile)
     =========================================== */

  function initStickyBuy() {
    var buyWrap = document.getElementById('op-buy-wrap');
    if (!buyWrap) return;

    function isMobile() { return window.innerWidth < 1024; }
    if (!isMobile()) return;

    var priceEl = document.getElementById('op-product-price');
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    var sticky = document.createElement('div');
    sticky.className = 'op-product__buy-sticky';
    sticky.innerHTML = '<button type="button" class="op-btn op-btn--primary op-btn--full op-sticky-buy-btn">' +
      'Buy It Now' + (priceText ? ' \u2014 ' + priceText : '') + '</button>';
    document.body.appendChild(sticky);

    sticky.querySelector('.op-sticky-buy-btn').addEventListener('click', function () {
      var realBtn = buyWrap.querySelector('.shopify-payment-button__button, [name="add"], button[type="submit"]');
      if (realBtn) {
        realBtn.click();
      } else {
        buyWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('hidden', entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px 80px 0px' });

    observer.observe(buyWrap);
  }

  /* ===========================================
     7. Filter Tabs (Homepage)
     =========================================== */

  function initFilterTabs() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.op-filter-tab');
      if (!tab) return;

      var filter = tab.dataset.filter;
      var wrapper = tab.closest('.op-filter-tabs, .op-collection');

      // Toggle active class among sibling tabs
      if (wrapper) {
        $$('.op-filter-tab', wrapper.parentElement).forEach(function (t) {
          t.classList.remove('active');
        });
      } else {
        $$('.op-filter-tab').forEach(function (t) {
          t.classList.remove('active');
        });
      }
      tab.classList.add('active');

      // Show / hide product cards
      var cards = $$('[data-filter]');
      cards.forEach(function (card) {
        if (!filter || filter === 'all') {
          card.style.display = '';
        } else {
          card.style.display = card.dataset.filter === filter ? '' : 'none';
        }
      });
    });
  }

  /* ===========================================
     7. FAQ Accordion
     =========================================== */

  function initFAQ() {
    document.addEventListener('click', function (e) {
      var question = e.target.closest('.op-faq-item__question');
      if (!question) return;

      var item = question.closest('.op-faq-item');
      if (item) item.classList.toggle('open');
    });
  }

  /* ===========================================
     8. Scroll Reveal
     =========================================== */

  function initScrollReveal() {
    var targets = $$('.op-reveal');
    if (!targets.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ===========================================
     9. Smooth Scroll
     =========================================== */

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;

      var target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ===========================================
     10. Email Capture Form
     =========================================== */

  function initEmailCapture() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.op-email__form');
      if (!form) return;

      e.preventDefault();

      var wrapper = form.parentElement;
      wrapper.innerHTML =
        '<p class="op-email__success">You\'re on the list. Heat incoming. 🔥</p>';
    });
  }

  /* ===========================================
     Boot
     =========================================== */

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initStickyHeader();
    initMobileMenu();
    initCartDrawer();
    initDescriptionDrawer();
    initVariantSelector();
    initProductCarousel();
    initStickyBuy();
    initFilterTabs();
    initFAQ();
    initScrollReveal();
    initSmoothScroll();
    initEmailCapture();
  });
})();
